<template>
    <transition name="fade">
        <div 
            v-if="isShow"
            @click="handleClickOverlay"
            class="vc-overlay"
            id="vueModalPeque"
            style="z-index: 400;"
        >

        <transition name="zoom">
            <div class="vc-container " >
                <div class="vc-header" v-if="modalgrande.titulo">
                  <div class="vc-title">
                    <div class="vc-title-content" v-html="modalgrande.titulo"></div>
                   <div class="vc-close">
                      <button type="button"  class="close" @click="BotonCerrar()"  >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div> 
                  </div>
                
                </div>
               <!--  <div class="vc-body" v-html="editar.mensaje" style="text-align:center">
                </div> -->
                <div class="vc-footer">
                  <div class="row">
                    <div class="col-md-12 " style="padding: 5px 18px 5px 18px;" >
                      <slot ></slot>
                    </div>
                  </div>
                </div>
            </div>
        </transition>
        </div>
    </transition>       
</template>

<script>
export default {
props: ['modalgrande'],
name: 'vueModalGrande',
data() {
    return {
      isShow: true,
    }
  },
  methods: {
    handleClickOverlay({ target }) {
      if ( target.id == 'modalgrande') {
      this.modalgrande.isHistorialMarcaciones = false;
      this.modalgrande.isRegistroHorarios = false;
      this.modalgrande.isEmpleadosHorario = false;
      this.modalgrande.isVerEmpleados =false;
      this.modalgrande.isLecturaMasiva =false;
      this.modalgrande.isEdicionMasivaEmpleados=false;
      }
    },
    BotonCerrar(){
      this.modalgrande.isHistorialMarcaciones = false;  
      this.modalgrande.isRegistroHorarios = false;
      this.modalgrande.isEmpleadosHorario = false;
      this.modalgrande.isVerEmpleados =false;
      this.modalgrande.isLecturaMasiva =false;
      this.modalgrande.isEdicionMasivaEmpleados=false;
    }

  }
}
</script>
<style scoped>
.vc-container {
    width:90% !important;
}

.vc-footer{
  overflow-x: auto;
}
</style>